import { render, staticRenderFns } from "./QualityAssuranceLabelPublish.vue?vue&type=template&id=360a7ee8"
import script from "./QualityAssuranceLabelPublish.vue?vue&type=script&lang=js"
export * from "./QualityAssuranceLabelPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports